import { skipToken, useInfiniteQuery } from '@tanstack/react-query';

import { Assets, type ClipsListResponse } from '@air/api';
import { type Asset, type Clip, type Workspace } from '@air/api/types';

export const ASSET_VERSIONS_LIST_KEY = '@plugin-ui/ASSET_VERSIONS_LIST';

export const getAssetVersionsListKey = (params: UseAssetVersionsListParams) => {
  return [ASSET_VERSIONS_LIST_KEY, params];
};

export type UseAssetVersionsListParams = {
  assetId: Asset['id'] | undefined;
  workspaceId: Workspace['id'] | undefined;
};

export const useAssetVersionsList = (params: UseAssetVersionsListParams) => {
  const { assetId, workspaceId } = params;

  return useInfiniteQuery({
    enabled: !!assetId && !!workspaceId,
    getNextPageParam: (lastPage: ClipsListResponse<Clip>) => lastPage?.pagination?.cursor,
    initialPageParam: '',
    queryFn:
      assetId && workspaceId
        ? ({ pageParam }) =>
            Assets.listVersions({
              assetId,
              cursor: pageParam || null,
              limit: 500,
              workspaceId,
            })
        : skipToken,
    queryKey: getAssetVersionsListKey(params),
  });
};
